import React, { useState, useEffect } from "react";
import Cookies from "js-cookie"; // Ensure Cookies is imported
import CookiePopup from "./Cookies";

const CookieManager = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) {
      setShowPopup(true); // Show popup if no consent is given
    }
  }, []);

  return <>{showPopup && <CookiePopup />}</>;
};
export default CookieManager;
